(window as any).downloadFile = function (sUrl: string, filename: string) {
    // If in Chrome or Safari - download via virtual link click
    if (
        (window as any).downloadFile.isChrome ||
        (window as any).downloadFile.isSafari ||
        (window as any).downloadFile.isFirefox
    ) {
        // Creating new link node.
        // noinspection ES6ConvertVarToLetConst
        let link = document.createElement('a');
        link.href = sUrl;

        if (link.download !== undefined && !filename) {
            // Set HTML5 download attribute. This will prevent file from opening if supported.
            filename = sUrl.substring(sUrl.lastIndexOf('/') + 1, sUrl.length);
        }

        link.download = filename;

        // Dispatching click event.
        try {
            if (document.createEvent) {
                // noinspection ES6ConvertVarToLetConst
                let e = document.createEvent('MouseEvents');
                e.initEvent('click', true, true);
                link.dispatchEvent(e);
                //Pace.stop();
                return true;
            }
        } catch (e) {
            console.log(e);
        }
    }
};
(window as any).downloadFile.isChrome =
    navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
(window as any).downloadFile.isFirefox =
    navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
(window as any).downloadFile.isSafari =
    navigator.userAgent.toLowerCase().indexOf('safari') > -1;

export {};
